import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=2f35ef4e&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=2f35ef4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f35ef4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f35ef4e')) {
      api.createRecord('2f35ef4e', component.options)
    } else {
      api.reload('2f35ef4e', component.options)
    }
    module.hot.accept("./RichTextEditor.vue?vue&type=template&id=2f35ef4e&scoped=true", function () {
      api.rerender('2f35ef4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/editors/RichTextEditor.vue"
export default component.exports